module.exports = __webpack_public_path__ + "static/media/setup.2eaf9892.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/setup.svg
// module id = 97
// module chunks = 0